import { Marker as MapboxMarker } from 'mapbox-gl';
import { useEffect } from 'react';
import { renderToString } from 'react-dom/server';

import type { UseHomePointMarkerParams } from './types';

// Attaches a single mapbox `Marker` anchored at `bottom` to the map at the
// home point's lng/lat. The marker's DOM is produced by rendering the passed
// `markerElement` to an HTML string and injecting it into a container div.
//
// StrictMode note: the effect is stateless. Each change to `homePoint` (or
// `markerElement`) triggers cleanup → re-create, which removes the old marker
// and adds a fresh one at the new coordinates. No refs to reset.
const useHomePointMarker = ({ homePoint, map, markerElement }: UseHomePointMarkerParams) => {
    useEffect(() => {
        if (!map || !homePoint) {
            return;
        }

        const markerDiv = document.createElement('div');

        markerDiv.innerHTML = renderToString(markerElement);

        const marker = new MapboxMarker({ anchor: 'bottom', element: markerDiv })
            .setLngLat([homePoint.lon, homePoint.lat])
            .addTo(map);

        return () => {
            marker.remove();
        };
    }, [map, homePoint, markerElement]);
};

export default useHomePointMarker;
